<template>
  <v-dialog
    v-model="showDialog"
    width="500"
  >
    <template #activator="{ on }">
      <v-btn
        color="primary"
        v-on="on"
      >
        View Results
      </v-btn>
    </template>

    <v-card>
      <v-card-title
        class="headline grey lighten-2"
        primary-title
      >
        Results
      </v-card-title>

      <v-card-text class="text-left subtitle-2">
        <v-row>
          <v-col
            col="12"
            sm="6"
          >
            First Name: {{ contact.firstName }}
          </v-col>
          <v-col
            cols="12"
            sm="6"
          >
            Last Name: {{ contact.lastName }}
          </v-col>
          <v-col
            cols="12"
            sm="6"
          >
            Phone Number: {{ contact.phone }}
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-text class="text-left subtitle-2">
        <v-subheader>
          Epworth Sleepiness Scale
        </v-subheader>
        <div
          v-for="epworth in epworthProps.list"
          :key="epworth.epworthid"
          class="mb-1"
        >
          <v-chip
            :color="$utils.getGradeColor(epworth.selected)"
            small
          >
            {{ epworth.selected }}
          </v-chip>
          {{ epworth.epworth }}
        </div>
        <v-subheader>
          Health Symptoms
        </v-subheader>
        <div
          v-for="symptom in symptoms"
          :key="symptom.name"
        >
          <div v-if="symptom.value">
            <span class="success--text">Yes</span>
            {{ symptom.label }}
          </div>
        </div>
        <span
          :class="{
            'success--text': cpap.value,
            'error-text': !cpap.value
          }"
        >
          {{ cpap.value ? 'Yes' : 'No' }}
        </span>
        Have you ever used CPAP before?<br>

        <v-subheader>
          Co-morbidity
        </v-subheader>
        <div>
          Please check any conditions for
          which you have been medically diagnosed or treated.
        </div>
        <div
          v-for="morbidity in coMorbidity"
          :key="morbidity.name"
          class="error--text"
        >
          <div v-if="morbidity.value">
            {{ morbidity.label }}
          </div>
        </div>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          text
          @click="showDialog = false"
        >
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref } from '@vue/composition-api'
import {
  contact,
  cpap,
  symptoms,
  coMorbidity
} from '@/use/screener'
import { epworthProps } from '@/use/epworth'

export default {
  setup: () => {
    const showDialog = ref(false)

    return {
      showDialog,
      contact,
      cpap,
      symptoms,
      coMorbidity,
      epworthProps
    }
  }
}
</script>
